import { showNotification } from 'sonata-react-components';
import { DealInterface } from 'sonata-static-storage/lib/schemas/premium/deal.schema';

import { assignDealToUsers } from '@/services/assignDeals.service';
import { createDeal, updateDeal as updateDealService } from '@/services/deals.service';

import type { IntlFormatters } from 'react-intl';
import type { AssignedUser } from '@/components/common/AssignDealSection/AssignDealSection';

export type DealConfig = Partial<DealInterface> & {
  adExchange: string;
  id: string;
};

export async function updateDeal({
  dealConfig,
  formatMessage,
  id: internalId
}: {
  dealConfig: DealConfig;
  formatMessage: IntlFormatters['formatMessage'];
  id: string;
}): Promise<void> {
  const token = {};
  try {
    const { id, adExchange, ...restConfig } = dealConfig;
    await updateDealService(
      {
        ...restConfig,
        origin: {
          id,
          name: adExchange,
          ...restConfig.origin
        }
      },
      internalId,
      token
    );
    showNotification(
      'info',
      formatMessage({
        defaultMessage: 'The deal has been updated successfully.',
        id: 'menu.newDeal.updated'
      })
    );
  } catch (_) {
    showNotification(
      'error',
      formatMessage({
        defaultMessage: 'An error occurred while updating the deal. Please try again.',
        id: 'menu.newDeal.errorUpdating'
      })
    );
  }
}

export async function saveDeal({
  dealConfig,
  userId,
  formatMessage,
  newDealAssignedUsers
}: {
  dealConfig: DealConfig;
  userId: string;
  formatMessage: IntlFormatters['formatMessage'];
  newDealAssignedUsers: AssignedUser[];
}): Promise<void> {
  const createDealToken = {};
  const assignDealToken = {};
  try {
    const { id, adExchange, ...restConfig } = dealConfig;
    const deal = await createDeal(
      {
        ...restConfig,
        active: true,
        name: restConfig.alias,
        origin: {
          id,
          name: adExchange,
          ...(restConfig.origin ?? {})
        }
      },
      userId,
      createDealToken
    );
    await assignDealToUsers(
      deal._id,
      newDealAssignedUsers.map(user => user.id!),
      assignDealToken
    );
    showNotification(
      'info',
      formatMessage({
        defaultMessage: 'The deal has been created successfully.',
        id: 'menu.newDeal.created'
      })
    );
  } catch (_) {
    showNotification(
      'error',
      formatMessage({
        defaultMessage: 'An error occurred while creating the deal. Please try again.',
        id: 'menu.newDeal.errorCreating'
      })
    );
  }
}
